import { Fragment, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useOrderClarificationModal } from "../../Context/OrderClarificationPopUpContext";
import { GlobalContext } from "../../Context/GlobalContext";
import { axiosInstance } from "../../axios/axiosInstance";
import { isValidArray } from "../../Layout/Common/common";
import { LinkProductPage } from "../../Layout/Common/LinkProductPage";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { useAuth } from "../../Context/AuthContext";
import { useGlobalFunction } from "../../Context/GlobalFunctionContext";
import { showErrorSnackbar, showSuccessSnackbar } from "../../utils/snackbarNotifications";

export const OrderDetailClarification = (orderId = null) => {
  const { CartItem, OrderId, clarificationItem, setClarificationItem } = useContext(GlobalContext);

  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [orderErrorItem, setOrderErrorItem] = useState(null);
  const [isClarification, setIsClarification] = useState(false);
  const { userId } = useAuth();
  const { showOrderClarification, hideOrderClarification, isOrderClarification, setIsOrderClarification } =
    useOrderClarificationModal();

  let isShown = false;
  const { checkOrderClarification } = useGlobalFunction();
  // A specific orderId prop is only passed from the pending-order view. In that
  // case we must not use the global (cart-derived) clarificationItem, which may
  // be stale for a different order.
  const hasOrderIdProp = Boolean(orderId && orderId.orderId);
  useEffect(() => {
    if (orderId && orderId.orderId) {
      setSelectedOrderId(orderId.orderId);
    } else {
      setSelectedOrderId(OrderId);
    }
  }, [orderId]);
  useEffect(() => {
    if (hasOrderIdProp) {
      // Pending-order view: clear first, then populate solely from the
      // per-order fetch (GetErrorItem) based on the selected orderId.
      setOrderErrorItem(null);
      setIsClarification(false);
      GetErrorItem();
      return;
    }
    if (clarificationItem && isValidArray(clarificationItem)) {
      setIsClarification(true);
      clarificationItem.forEach((item, index) => {
        setTimeout(() => {
          setOrderErrorItem((prevCards) => (prevCards ? [...prevCards, item] : [item]));
        }, index * 100);
      });
    } else {
      setOrderErrorItem(null);
      setIsClarification(false);
    }
    GetErrorItem();
  }, [clarificationItem, selectedOrderId]); // Remove selectedOrderId if it causes issues

  useEffect(() => {
    if (isClarification === true) {
      if (!isShown) {
        isShown = true;
        showOrderClarification();
      }
    }
  }, [isClarification]);

  const GetErrorItem = async () => {
    if (userId && selectedOrderId) {
      const response = await axiosInstance.post("MyCart/GetOrderClarification", {
        userId: String(userId),
        orderId: String(selectedOrderId),
      });
      if (response.data) {
        let res = response.data;
        if (res.statusCode != -1 && isValidArray(res.data)) {
          setIsClarification(true);
          res.data.forEach((item, index) => {
            setTimeout(() => {
              setOrderErrorItem((prevCards) => (prevCards ? [...prevCards, item] : [item]));
            }, index * 100);
          });
        } else setIsClarification(false);
      }
    }
  };
  const handleRemoveItem = (orderCode, callback) => {
    axiosInstance
      .post("MyCart/RemoveOrderClarification", {
        sku: String(orderCode),
        userId: String(userId),
      })
      .then((response) => {
        if (response && response.data && response.data.status === 1) {
          showSuccessSnackbar("Clarification item removed successfully.");
          setOrderErrorItem((prevCards) => prevCards.filter((card) => card.orderCode != orderCode));
          setClarificationItem((prevCards) => prevCards.filter((card) => card.orderCode != orderCode));
        } else {
          showErrorSnackbar("Failed to remove the item. Please try again.");
        }
      })
      .catch((error) => {
        showErrorSnackbar("Failed to remove the item. Please try again.");
      })
      .finally(() => {
        if (callback) callback();
      });
  };
  return (
    <Fragment>
      {orderErrorItem && (
        <div class="row">
          <div class="col-lg-12 order-clarification-info">
            <TransitionGroup>
              {orderErrorItem.map((item, index) => (
                <CSSTransition key={item.orderCode} timeout={300} classNames="card">
                  {item.style == "BLUE" ? (
                    <ErrorItemBlue item={item} index={index} handleAction={handleRemoveItem} />
                  ) : item.style == "RED" ? (
                    <ErrorItemRed item={item} index={index} handleAction={handleRemoveItem} />
                  ) : (
                    <ErrorItemOrange item={item} index={index} handleAction={handleRemoveItem} />
                  )}
                </CSSTransition>
              ))}
            </TransitionGroup>
          </div>
        </div>
      )}
    </Fragment>
  );
};

const ErrorItemRed = ({ item, index, handleAction }) => {
  const [isClicked, setIsClicked] = useState(false);
  const handleCallback = () => {
    setIsClicked(false);
  };

  const handleRemove = () => {
    setIsClicked(true);
    handleAction(item.orderCode, handleCallback);
  };
  return (
    <Fragment>
      {item && (
        <div
          className="order-clarification not-found"
          key={index}
          style={{
            opacity: isClicked ? 0.5 : 1,
          }}
        >
          <div className="order-clarification-lft">
            <h5>
              <span className="wes-alert" /> {item.clarificationMessage}
            </h5>
            {item.prod_desc && (
              <h6>
                <LinkProductPage productId={item.productId} productCode={item.orderCode} value={item.prod_desc} />
              </h6>
            )}
            <p>{`Code: ${item.orderCode} ${item.clarificationType === "ITEM_DISCONTINUED" ? "is discontinued" : "Not Found / Incorrect Code"}`}</p>
          </div>
          <div className="order-clarification-rht">
            <button type="submit" className="cc-cart-delete" onClick={handleRemove}>
              <i className="fa-regular fa-trash-can" />
            </button>
          </div>
        </div>
      )}
    </Fragment>
  );
};

const ErrorItemOrange = ({ item, index, handleAction }) => {
  const [isClicked, setIsClicked] = useState(false);

  const handleCallback = () => {
    setIsClicked(false);
  };

  const handleRemove = () => {
    setIsClicked(true);
    handleAction(item.orderCode, handleCallback);
  };

  return (
    <Fragment>
      {item && (
        <div
          className="order-clarification temporarily-unavailable"
          key={index}
          style={{
            opacity: isClicked ? 0.5 : 1,
          }}
        >
          <div className="order-clarification-lft">
            <h5>
              <span className="wes-alert" /> {item.clarificationMessage}
            </h5>
            <h6>
              <LinkProductPage productId={item.productId} productCode={item.orderCode} value={item.prod_desc} />
            </h6>
            <p>Code: {item.orderCode} is currently unavailable</p>
          </div>
          <div className="order-clarification-rht">
            <button type="submit" className="cc-cart-delete" onClick={handleRemove}>
              <i className="fa-regular fa-trash-can" />
            </button>
          </div>
        </div>
      )}
    </Fragment>
  );
};

const ErrorItemBlue = ({ item, index, handleAction }) => {
  const [isClicked, setIsClicked] = useState(false);

  const handleCallback = () => {
    setIsClicked(false);
  };

  const handleRemove = () => {
    setIsClicked(true);
    handleAction(item.orderCode, handleCallback);
  };

  return (
    <Fragment>
      {item && (
        <div
          className="order-clarification product-notAvailable"
          key={index}
          style={{
            opacity: isClicked ? 0.5 : 1,
          }}
        >
          <div className="order-clarification-lft">
            <h5>
              <span className="wes-alert" /> {item.clarificationMessage}
            </h5>
            <h6>
              <LinkProductPage productId={item.productId} productCode={item.orderCode} value={item.prod_desc} />
            </h6>
            <LinkProductPage
              productId={item.replaceItemId}
              productCode={item.replaceItemCode}
              value={` View Replacement Product : ${item.replaceItemCode}`}
            />
          </div>
          <div className="order-clarification-rht">
            <button type="submit" className="cc-cart-delete" onClick={handleRemove}>
              <i className="fa-regular fa-trash-can" />
            </button>
          </div>
        </div>
      )}
    </Fragment>
  );
};
